var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"theme":"banner","buttonText":"Accetto","transitionName":"fade","message":"Questo sito utilizza cookies a fini statistici e per migliorare l’esperienza utente."}})}
var staticRenderFns = []

export { render, staticRenderFns }